/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card image instance
 *
 * @module enervee_utils.product_card
 */
function productCardDescriptionDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '='
        },
        template: require('./descriptionView.html')
    };
}

module.exports = productCardDescriptionDirective
